import { render } from "./ExcelFakerPage.vue?vue&type=template&id=50857c87&scoped=true"
import script from "./ExcelFakerPage.vue?vue&type=script&lang=js"
export * from "./ExcelFakerPage.vue?vue&type=script&lang=js"

import "./ExcelFakerPage.vue?vue&type=style&index=0&id=50857c87&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50857c87"]])

export default __exports__